import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let state = { drop: null, at: 0 };
const subs = new Set();
let timer = null;

const emit = () => subs.forEach((f) => f(state));

export async function refreshDrop() {
  try {
    const { data } = await api.get("/drops/active");
    state = { drop: data.drop, at: Date.now() };
  } catch { /* offline */ }
  emit();
}

export function markClaimed(claims) {
  if (state.drop) state = { ...state, drop: { ...state.drop, claimed: true, claims: claims ?? state.drop.claims } };
  emit();
}

const onVis = () => document.visibilityState === "visible" && refreshDrop();

export function useDrop() {
  const [s, setS] = useState(state);
  useEffect(() => {
    subs.add(setS);
    if (subs.size === 1) {
      refreshDrop();
      timer = setInterval(refreshDrop, 60000);
      document.addEventListener("visibilitychange", onVis);
    }
    return () => {
      subs.delete(setS);
      if (!subs.size) { clearInterval(timer); document.removeEventListener("visibilitychange", onVis); }
    };
  }, []);
  return s;
}

// seconds left, based on server value (no device-clock drift)
export function useDropCountdown(s) {
  const end = s.drop ? s.at + s.drop.seconds_left * 1000 : 0;
  const [left, setLeft] = useState(() => Math.max(0, Math.round((end - Date.now()) / 1000)));
  useEffect(() => {
    if (!end) return undefined;
    const tick = () => {
      const l = Math.max(0, Math.round((end - Date.now()) / 1000));
      setLeft(l);
      if (l === 0) refreshDrop();
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [end]);
  return left;
}

export const mmss = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

export const DROP_GRAD = {
  rose: "from-pink-400 to-rose-600", gold: "from-amber-300 to-orange-500", violet: "from-violet-400 to-fuchsia-600",
  sky: "from-sky-400 to-indigo-500", emerald: "from-emerald-400 to-teal-600",
};
